module.exports = __webpack_public_path__ + "img/ico_biaoqianzhanwen.11d839d6.png";